import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Registration } from 'src/app/models/registration';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-partipian-documents',
  templateUrl: './partipian-documents.component.html',
  styleUrls: ['./partipian-documents.component.scss'],
})
export class PartipianDocumentsComponent implements OnInit {
  @Input() dialogData!: Registration;
  @Input() dialogConfirmed: boolean = false;
  @Output() dialogConfirmedChange: EventEmitter<boolean> = new EventEmitter();
  @Output() saveDocumentsEvent: EventEmitter<Registration> = new EventEmitter();
  dialogConfirmedShow = true;

  constructor(public appSettings: SettingsService) {}

  ngOnInit() {
    // setTimeout(() => {
    //   this.dialogConfirmedShow = true;
    // },100);
  }

  saveDocuments(dialogData?: Registration) {
    if (dialogData) {
      this.saveDocumentsEvent.emit(dialogData);
    }
    this.dialogConfirmed = !this.dialogConfirmed;
    this.dialogConfirmedChange.emit(this.dialogConfirmed);
  }

   sanitizePositiveInt(value: number): number {
    if (isNaN(value) || value < 0) {
      return 0;
    }
    return Math.floor(value);
  }
}
